import React, { useEffect, useState } from "react";
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import { log } from "../utils/logUtils";

function CropImage({ style, imageUrl, alt, setCroppedImage, isMobile }) {
    const [crop, setCrop] = useState({ aspect: 1 });
    const [croppedImageUrl, setCroppedImageUrl] = useState(null);
    const [imageRef, setImageRef] = useState(null);

    useEffect(() => {
        if(imageUrl) {
            onImageLoaded(imageUrl);
        }
    }, [imageUrl]);

    const onImageLoaded = async (image) => {
        // Fetch the image as a blob
        const response = await fetch(image, { mode: 'cors' }); // You can try without 'cors' if it's a public bucket
        const blob = await response.blob();
        
        // Create an image element
        const newImage = new Image();
        newImage.src = URL.createObjectURL(blob);

        // Ensure the image is loaded before doing anything with it
        newImage.onload = () => {
            // At this point, you can access newImage.width and newImage.height
            log(newImage.width, "Original S3 Image Width:", false, false);
            log(newImage.height, "Original S3 Image Height:", false, false);
        
            // Set the image reference for later use (for drawing on canvas, etc.)
            setImageRef(newImage);
        };
    };
  
    const onCropComplete = (crop) => {
        if (imageRef && crop.width && crop.height) {
            makeCroppedImage(imageRef, crop);
        } else {
            setCroppedImageUrl(null);
            setCroppedImage(null);
        }
    };
  
    const onCropChange = (crop) => {
        setCrop(crop);
    };
  
    const makeCroppedImage = (originalImage, crop) => {
        const element = document.getElementById("image-being-cropped");  
        const canvas = document.createElement('canvas');
        const scaleX = originalImage.naturalWidth / element.width;
        const scaleY = originalImage.naturalHeight / element.height;
        canvas.width = crop.width;
        canvas.height = crop.height;
        const ctx = canvas.getContext('2d');
    
        ctx.drawImage(
            originalImage,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width,
            crop.height
        );
    
        const base64Image = canvas.toDataURL('image/jpeg');
        setCroppedImageUrl(base64Image);
        setCroppedImage(base64Image);
    };
  
    return (
        <div style={isMobile ? {} : { "display": "flex" }}>
            {imageUrl ? (
                <ReactCrop
                    aspect={4 / 3}
                    src={imageRef}
                    crop={crop}
                    onImageLoaded={onImageLoaded}
                    onComplete={onCropComplete}
                    onChange={onCropChange}
                >
                    <img id="image-being-cropped" style={{ ...style }} src={imageUrl} alt={alt}/>
                </ReactCrop>
            ) : null}
            {croppedImageUrl ? (
                <div style={isMobile ? {} : { "marginLeft": "16px" }}>
                    <img alt={`Cropped ${alt}`} style={{ ...style }} src={croppedImageUrl} />
                </div>
            ) : null}
        </div>
    );
};

export default CropImage;